import { Link } from 'react-router';
import { Button } from '@monksflow/monks-ui';

interface TabLinkButtonProps {
  to?: string;
  isActive?: boolean;
  icon?: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
  centered?: boolean;
  onClick?: () => void;
}

export const TabLinkButton = ({
  to,
  isActive,
  icon: Icon,
  onClick,
  centered = true,
  children,
}: TabLinkButtonProps) => {
  const content = (
    <>
      {Icon && <Icon className="size-5" />}
      {children}
    </>
  );

  const className = `h-auto w-42.5 p-5 ${centered ? 'justify-center' : 'justify-start'}`;
  // eslint-disable-next-line i18next/no-literal-string -- design-system variant names, never rendered
  const variant = isActive ? 'secondary' : 'ghost';

  if (to) {
    return (
      <Button asChild variant={variant} className={className}>
        <Link to={to} onClick={onClick}>
          {content}
        </Link>
      </Button>
    );
  }

  return (
    <Button type="button" variant={variant} className={className} onClick={onClick}>
      {content}
    </Button>
  );
};
